export const ANSWER_TYPES = ['answer', 'file', 'website'];
export const ANSWER_FILE_TYPES = ['file', 'website'];
export const WEBSITE_NO_PAGE_SELECTED_ERROR_MESSAGE = 'Select atleast 1 page!';
